"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Diff = exports.DiffCharacterSplitter = exports.DiffWordSplitter = exports.estimateSplitType = void 0;
function estimateSplitType(langId) {
    if (langId.includes("ja") || langId.includes("jp") || langId.includes("kr"))
        return "character";
    return "word";
}
exports.estimateSplitType = estimateSplitType;
function splitCharacter(target) {
    return (sentence) => {
        return sentence.split(target).reduce((prev, cur, i) => {
            if (i === 0) {
                if (cur !== "")
                    return [...prev, cur];
                return prev;
            }
            if (cur !== "")
                return [...prev, target, cur];
            return [...prev, target];
        }, []);
    };
}
const DiffWordSplitter = (sentence) => {
    return (sentence !== null && sentence !== void 0 ? sentence : "")
        .replace("\r\n", "\n")
        .split(" ")
        .map(splitCharacter("\n"))
        .reduce((prev, cur) => [...prev, ...cur], [])
        .map(splitCharacter("."))
        .reduce((prev, cur) => [...prev, ...cur], [])
        .map(splitCharacter(","))
        .reduce((prev, cur) => [...prev, ...cur], [])
        .map(splitCharacter("+"))
        .reduce((prev, cur) => [...prev, ...cur], [])
        .map(splitCharacter("!"))
        .reduce((prev, cur) => [...prev, ...cur], [])
        .map(splitCharacter("?"))
        .reduce((prev, cur) => [...prev, ...cur], []);
};
exports.DiffWordSplitter = DiffWordSplitter;
const DiffCharacterSplitter = (sentence) => Array.from(sentence !== null && sentence !== void 0 ? sentence : "");
exports.DiffCharacterSplitter = DiffCharacterSplitter;
class Diff {
    constructor(type) {
        this.type = type;
        if (this.type === "word") {
            this.splitter = exports.DiffWordSplitter;
        }
        else if (this.type === "character") {
            this.splitter = exports.DiffCharacterSplitter;
        }
        else {
            throw new Error("Unreachable");
        }
    }
    calculate(source, target) {
        const sourceItems = this.splitter(source);
        const targetItems = this.splitter(target);
        if (sourceItems.length === 0 || targetItems.length === 0)
            return [];
        // src.length + 1 x tgt.length + 1 の 0 配列
        // dp[i][j] = (S側配列前からi個, T側配列前からj個) からなる文字列に対して, いくつ同じ文字列の区間があるか
        const dp = Array.from({ length: sourceItems.length + 1 }, () => Array(targetItems.length + 1).fill(0));
        sourceItems.forEach((wordS, i) => {
            targetItems.forEach((wordT, j) => {
                dp[i + 1][j + 1] = this.compareWords(wordS, wordT)
                    ? dp[i][j] + 1
                    : Math.max(dp[i][j + 1], dp[i + 1][j]);
            });
        });
        // S側 i+1 番目とT側 j+1 番目が一致するなら dp[i][j]+1 が答え
        // そうでないならS側を一個減らす or T側を一個減らして前計算したものと答えが一致する
        const res = [];
        let [i, j] = [sourceItems.length, targetItems.length];
        while (i > 0 && j > 0) {
            if (dp[i][j] === dp[i - 1][j])
                i--;
            else if (dp[i][j] === dp[i][j - 1])
                j--;
            else
                res.push([--i, --j]); // 一致を見つけた場合
        }
        // どのように遷移したかを復元
        res.reverse();
        return res;
    }
    isPerfectlyMatched(source, target) {
        const allPairs = this.calculate(source, target);
        const targetItems = this.splitter(target);
        const sourceItems = this.splitter(source);
        return (allPairs.length === targetItems.length &&
            allPairs.length === sourceItems.length);
    }
    compareWords(s, t) {
        if (this.type === "word")
            return s.trim().toLowerCase() === t.trim().toLowerCase();
        // MEMO: Here, we might want to add hiragana-katakana translation
        if (this.type === "character")
            return s === t;
        throw new Error("Unreachable");
    }
}
exports.Diff = Diff;
